/**
 * T039: useAuth Hook
 * Query hook for getting current user authentication state
 */

import { useQuery } from '@tanstack/react-query'
import { useEffect } from 'react'
import { getMe } from '@/services/auth'
import { useAuthStore } from '@/stores/auth'
import { queryKeys } from '@/lib/query-keys'

export function useAuth() {
  const { setUser, signOut } = useAuthStore()

  const query = useQuery({
    queryKey: queryKeys.auth.me(),
    queryFn: getMe,
    retry: false,
    staleTime: 1000 * 60 * 5, // 5 minutes
  })

  // Sync query result with auth store
  useEffect(() => {
    if (query.data?.user) {
      setUser(query.data.user)
    } else if (query.error) {
      signOut()
    }
  }, [query.data, query.error, setUser, signOut])

  return {
    user: query.data?.user ?? null,
    isLoading: query.isLoading,
    isAuthenticated: !!query.data?.user,
    error: query.error,
    refetch: query.refetch,
  }
}
